import { render, staticRenderFns } from "./TripNew.vue?vue&type=template&id=511ba0c8&scoped=true&"
import script from "./TripNew.vue?vue&type=script&lang=js&"
export * from "./TripNew.vue?vue&type=script&lang=js&"
import style0 from "./TripNew.vue?vue&type=style&index=0&id=511ba0c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "511ba0c8",
  null
  
)

export default component.exports